import {ref} from "vue";
import {db} from "@/firebase/config";

let useCollection = (collection)=>{
    let errorMessage = ref(null);// when call useCollection, return error every time.
    let addDoc = async(doc)=>{
        try {
            let res = await db.collection(collection).add(doc);
            return res;
        }catch (e) {
            console.log(e.message);
            errorMessage.value="Can't send the message!";
        }
    }
    return {errorMessage, addDoc};
}
export default useCollection;